import scrollLock from "./scrollLock";

export default function modalWindow() {
    const openingButtons = document.querySelectorAll("[data-modal]");

    openingButtons && openingButtons.forEach(button => {
        const modalId = button.getAttribute("data-modal");
        const modal = document.querySelector(`#${modalId}`);

        if (modal) {
            const handleModal = type => {
                if (type === "open") {
                    scrollLock.enable();
                    modal.classList.add("open");
                } else {
                    scrollLock.disable();
                    modal.classList.remove("open");
                }
            };

            button.addEventListener("click", event => {
                event.preventDefault();
                handleModal("open");
            });

            const closeButtons = modal.querySelectorAll("[data-close-modal]");
            closeButtons && closeButtons.forEach(closeButton => {
                closeButton.addEventListener("click", event => {
                    event.preventDefault();
                    handleModal();
                });
            });

            const toggleButtons = modal.querySelectorAll("[data-toggle-modal]");
            toggleButtons && toggleButtons.forEach(toggleButton => {
                toggleButton.addEventListener("click", () => modal.classList.remove("open"));
            });

            document.addEventListener("click", event => (event.target === modal) && handleModal());
            document.addEventListener("keydown", event => (event.keyCode === 27) && handleModal());
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/modalWindow.js